/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A diet followed by an individual.
 *
 * High meat-eater is someone consuming over 100 grams of meat per day, medium is 50-99 grams per day
 * and low is less than 50 grams per day. A fish eater is someone that doesn't consume meat other than
 * fish.
 *
 */
export var Diet;
(function (Diet) {
    Diet["HIGH_MEAT_EATER"] = "high_meat_eater";
    Diet["MEDIUM_MEAT_EATER"] = "medium_meat_eater";
    Diet["LOW_MEAT_EATER"] = "low_meat_eater";
    Diet["FISH_EATER"] = "fish_eater";
    Diet["VEGETARIAN"] = "vegetarian";
    Diet["VEGAN"] = "vegan";
})(Diet || (Diet = {}));
//# sourceMappingURL=Diet.js.map